import { CMSResource } from "app/resources/cmsresource";
import { DepartmentScheduleIntervalResponse } from "./DepartmentScheduleIntervalResponse";

export class DepartmentScheduleIntervalListResponse extends CMSResource{
    intervals: DepartmentScheduleIntervalResponse[]
    errorDays: string[];
}